import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import store from '@/store/store'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
    {
        path: '/',
        redirect: '/login',
        beforeEnter: (to, from, next) => {
            manageNavbar(false, false)
            next()
        },
    },
    {
        path: '/login:param?',
        component: () => import('../views/LoginPage.vue'),
        beforeEnter: (to, from, next) => {
            manageNavbar(false, false)
            next()
        },
    },
    {
        path: '*',
        redirect: '/equipment',
        component: () => import('../views/EmptyPage.vue'),
        meta: { auth: true },
    },
    {
        path: '/404',
        redirect: '/equipment',
        meta: { auth: true },
        beforeEnter: (to, from, next) => {
            manageNavbar(false, false)
            next()
        },
    },
    {
        path: '/equipment',
        name: 'equipment',
        component: () => import('@/views/equipment/EquipmentPage.vue'),
        meta: { auth: true },
        beforeEnter: (to, from, next) => {
            manageNavbar(true, true)
            next()
        },
    },
    {
        path: '/sites',
        name: 'sites',
        component: () => import('@/views/site/SitesPage.vue'),
        meta: { auth: true },
        beforeEnter: (to, from, next) => {
            manageNavbar(true, true)
            next()
        },
    },
    {
        path: '/sites/:id',
        name: 'site_details',
        component: () => import('@/views/site/SiteDetailsPage.vue'),
        meta: { auth: true },
        beforeEnter: (to, from, next) => {
            manageNavbar(false, false)
            next()
        },
    },
    {
        path: '/consumption_tracking/:id',
        name: 'consumption_tracking',
        component: () => import('@/views/site/SiteDetailsPage.vue'),
        meta: { auth: true },
        beforeEnter: (to, from, next) => {
            manageNavbar(true, true)
            next()
        },
    },
    {
        path: '/subscription',
        name: 'subscription',
        component: () => import('@/views/subscription/SubscriptionPage.vue'),
        meta: { auth: true },
        beforeEnter: (to, from, next) => {
            manageNavbar(true, true)
            next()
        },
    },
    {
        path: '/parameter',
        name: 'parameter',
        component: () => import('../views/ParameterPage.vue'),
        meta: { auth: true },
        beforeEnter: (to, from, next) => {
            manageNavbar(false, false)
            next()
        },
    },
    {
        path: '/parameter/customisation',
        component: () => import('@/views/parameter/customisation/CustomisationPage.vue'),
        meta: { auth: true },
        beforeEnter: (to, from, next) => {
            manageNavbar(false, false)
            next()
        },
    },
    {
        path: '/parameter/customisation/navigation',
        name: 'parameter_customisation_navigation',
        component: () => import('@/views/parameter/customisation/CustomisationNavigationPage.vue'),
        meta: { auth: true },
        beforeEnter: (to, from, next) => {
            manageNavbar(false, false)
            next()
        },
    },
    {
        path: '/parameter/management_user',
        name: 'management_user',
        component: () => import('../views/ManagementUserPage.vue'),
        meta: { auth: true },
        beforeEnter: (to, from, next) => {
            manageNavbar(false, true)
            next()
        },
    },
    {
        path: '/parameter/manage_space',
        name: 'manage_space',
        component: () => import('@/views/parameter/ManageSpacePage.vue'),
        meta: { auth: true },
        beforeEnter: (to, from, next) => {
            manageNavbar(false, false)
            next()
        },
    } /*
    {
        path: '/parameter/subscription_payment',
        name: 'subscription_payment',
        component: () => import('../views/Parameter/Subscription/SubscriptionPaymentPage.vue'),
        meta: {auth: true},
        beforeEnter: (to, from, next) => {
            manageNavbar(false, false);
            if (store.getters['tanks/getDevicesContractPaidByPro']) {
                next('/parameter');
            }
            next();
        }
    },
    {
        path: '/parameter/subscription_payment/subscription',
        name: 'subscription',
        component: () => import('../views/Parameter/Subscription/SubscriptionPage.vue'),
        meta: {auth: true},
        beforeEnter: (to, from, next) => {
            manageNavbar(false, false);
            if (store.getters['tanks/getDevicesContractPaidByPro']) {
                next('/parameter');
            }
            next();
        }
    },*/,
    {
        path: '/documents',
        name: 'documents',
        component: () => import('../views/DocumentPage.vue'),
        meta: { auth: true },
        beforeEnter: (to, from, next) => {
            manageNavbar(true, true)
            next()
        },
    },
    {
        path: '/profile',
        name: 'profile',
        component: () => import('../views/ProfilePage.vue'),
        meta: { auth: true },
        beforeEnter: (to, from, next) => {
            manageNavbar(false, false)
            next()
        },
    },
    {
        path: '/notifications',
        name: 'notifications',
        component: () => import('../views/NotificationPage.vue'),
        meta: { auth: true },
        beforeEnter: (to, from, next) => {
            manageNavbar(false, false)
            next()
        },
    },
    {
        path: '/gear',
        name: 'gear',
        component: () => import('../views/EnginPage.vue'),
        meta: { auth: true },
        beforeEnter: (to, from, next) => {
            manageNavbar(true, true)
            next()
        },
    },
    {
        path: '/orders_cockpit',
        name: 'orders_cockpit',
        component: () => import('@/views/order-cockpit/OrderCockpitPage.vue'),
        meta: { auth: true },
        beforeEnter: (to, from, next) => {
            manageNavbar(true, true)
            next()
        },
    },
    {
        path: '/orders_cockpit/:id',
        name: 'order_cockpit',
        component: () => import('@/views/order-cockpit/DetailsOrderCockpitPage.vue'),
        meta: { auth: true },
        beforeEnter: (to, from, next) => {
            manageNavbar(false, false)
            next()
        },
    },
    {
        path: '/stickers/:show_alert?',
        name: 'stickers',
        component: () => import('@/views/stickers/StickersPage.vue'),
        meta: { auth: true },
        beforeEnter: (to, from, next) => {
            manageNavbar(true, true)
            next()
        },
    },
    {
        path: '/equipment/manage_alert/:id',
        name: 'manage_alert',
        component: () => import('@/views/alert/ManageAlertPage.vue'),
        meta: { auth: true },
        beforeEnter: (to, from, next) => {
            manageNavbar(false, false)
            next()
        },
    },
    {
        path: '/news',
        name: 'news',
        component: () => import('../views/NewsPage.vue'),
        meta: { auth: true },
        beforeEnter: (to, from, next) => {
            manageNavbar(true, true)
            next()
        },
    },
    {
        path: '/index/overviewDevice/:uid',
        name: 'redirectToQrCodePublicV1',
        component: () => import('../views/RedirectToQrCodePublicV1.vue'),
        beforeEnter: (to, from, next) => {
            manageNavbar(false, false)
            next()
        },
    },
]

function manageNavbar(show_left_navbar, show_bottom_navbar) {
    store.commit('manage_navbar/manageNavbar', {
        show_left_navbar: show_left_navbar,
        show_bottom_navbar: show_bottom_navbar,
    })
}

const router = new VueRouter({
    mode: 'history',
    routes: routes,
})

export default router
